<template>
<div>
  <router-link to="/product/add" class="btn btn-primary float-right my-3"> <i class="bi bi-plus-lg"></i> নতুন প্রোডাক্ট যোগ করুন</router-link>
  <h3 class="py-3 text-bold">প্রোডাক্টের তালিকা</h3>
  <b-table striped hover :items="items" :fields="fields">
    <template #cell(limit)="data">
      <b class="bn-number"> {{ AmountService.commaDecimal(data.item.limit) }} </b>
    </template>
    <template #cell(stock)="data">
      <b class="bn-number"> {{ AmountService.commaDecimal(data.item.stock) }} </b>
    </template>
    <template #cell(actions)="row">
      <b-link size="sm" class="btn btn-primary float-center" variant="success" :to="row.item.link">
        তথ্য হালনাগাদ
      </b-link>
    </template>
  </b-table>
</div>
</template>

<script>
import Product from "@/services/DataStructure/Product/Product";
import AmountService from "../../services/amountService";
// import TransactionInfo from "@/services/DataStructure/TransactionInfo";
import StockService from "@/services/stockService";
//
export default {
  name: "ProductList",
  computed: {
    AmountService() {
      return AmountService
    }
  },
  props: {
    type: String
  },
  data(){
    return{
      items:[],
      fields:[
        {
          key: 'primaryName',
          label: "নাম (বাংলায়)"
        },
        {
          key: 'secondaryName',
          label: "নাম (ইংরেজি)"
        },
        {
          key: 'type',
          label: "প্রোডাক্টের ধরণ"
        },
        {
          key: 'limit',
          label: "স্টক সীমা"
        },
        {
          key: 'stock',
          label: "বর্তমান স্টক"
        },
        {
          key: 'note',
          label: "নোট"
        },
        'actions'],
    }
  },
  methods: {
    stockAnalysis(pid) {
      StockService.stockAnalysis(pid)
  },
   async loadData(){
      this.$swal.showLoading();
      let data = await Product.getProducts()
      this.$swal.close();
      if(data)
      {
          data.map((x)=>{
          x.type = this.getProductTypeTranslation(x.type)
          x.stock = x.stock.toFixed(2)
          x.link = "/product/edit/" + x.id
          if(x.limit>x.stock){
            x._rowVariant= 'danger'
          }else if((x.stock/x.limit)<1.25){
            x._rowVariant= 'warning'
          }
        })
      }
      this.items = data?data:[]
    },
    getProductTypeTranslation(productType){
      const category = this.$config.category.find(cat => cat.category_slug === productType);
      return category ? category.category_name : null;
    }
  },
  watch:{
    type(){
      this.loadData()
    }
  },
  created() {
    this.loadData()
  }
}
</script>

<style scoped>

</style>